<template>
  <div class="fixed inset-0 z-20 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0"
    >
      <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
      <div class="fixed inset-0 transition-opacity" @click="$emit('close')">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span
      >&#8203;
      <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
      <div
        class="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <div class="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div
              class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-indigo-100 rounded-full sm:mx-0 sm:h-10 sm:w-10"
            >
              <!-- Heroicon name: exclamation -->
              <svg
                class="w-6 h-6 text-indigo-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3
                class="text-lg font-medium leading-6 text-gray-900"
                id="modal-headline"
              >
                Subir comprobante
              </h3>
              <div class="mt-2">
                <div class="text-sm leading-5 text-gray-600">
                  <strong>Nombre: </strong>{{ inscription.customer.name }}
                </div>
                <div class="text-sm leading-5 text-gray-600">
                  <strong>Correo: </strong>{{ inscription.customer.email }}
                </div>
                <div class="text-sm leading-5 text-gray-600">
                  <strong>Teléfono: </strong>{{ inscription.customer.phone }}
                </div>
                <div class="flex text-sm leading-5 text-gray-600">
                  <strong>Monto a Verificar: </strong>
                  <w-price
                    :value="inscription.customPrice || eventPrice"
                  ></w-price>
                </div>
              </div>
            </div>
          </div>
          <w-upload
            class="mt-3"
            v-model="uploadStatus"
            @uploaded="saveReceipt($event)"
          />
        </div>
        <div class="px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse">
          <!-- <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button type="button" class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:ring-red sm:text-sm sm:leading-5">
            Guardar
          </button>
        </span> -->
          <span class="flex w-full mt-3 rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button
              @click="$emit('close')"
              type="button"
              class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue sm:text-sm sm:leading-5"
            >
              Cancelar
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex"
    export default {
        props: ["inscription", "eventPrice"],
        data() {
          return {
            uploadStatus: null,
            receiptUrl: null
          }
        },
        methods: {
              ...mapActions("inscriptions", {
      patchInscription: "patch"
    }),
          async saveReceipt(receiptUrl) {
            this.receiptUrl = receiptUrl;
            this.uploadStatus = "success";
            await this.patchInscription([
              this.inscription._id,
              { receipt: this.receiptUrl, payment: "paid", paidAt: new Date() },
              {}
            ]);
            this.$emit("saved");
            this.$emit("close");
          },
        },
    }
</script>

<style lang="scss" scoped>
</style>